import { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { useApiClient } from '../context/AppContext';
import permissionApi from "../api/permissionApi";
import { IRole } from "../types/Permission/IRoles";

const useRoles = () => {
    const apiClient = useApiClient();
    const { accounts } = useMsal(); //  Include accounts needed to determine when to fetch roles
    const [apiRoles, setApiRoles] = useState<IRole[]>([]);
    const [rolesError, setRolesError] = useState<Error | null>(null); 

    useEffect(() => {
        // Limit the API call to when accounts are available and apiRoles is empty.
        if (Array.isArray(accounts) && accounts.length !== 0 && apiRoles.length === 0) {
            setRolesError(null);

            permissionApi.GetRoles(apiClient)
                .then((roles) => {
                    setApiRoles(Array.isArray(roles) ? roles : [roles]);
                })
                .catch((err) => {
                    console.error("Error fetching API roles:", err);
                    setApiRoles([]);
                    setRolesError(err);
                });
        }
    }, [accounts, apiClient, apiRoles.length]);

    return { apiRoles, rolesError };
};

export default useRoles;